import { WorkflowsManager } from "../manager/ManageWorkflow";
import { Tabs } from "@shared/ui/tabs";
import { WorkflowHistory } from "../history/history";
import { useWorkflowRuns } from "../../hooks";
import { Button } from "@shared/ui/button";
import { useNavigate } from "react-router-dom";

export const Workflows = () => {
  const { data: workflowRuns, isLoading, isError } = useWorkflowRuns();
  const navigate = useNavigate();

  return (
    <div className="">
      <div className="flex justify-between">
        <div className="mb-6">
          <h1 className="page-title">Communication Workflows</h1>
          <p className="page-subtitle">
            Create and automate communication sequences for your audiences.
          </p>
        </div>
        <Button onClick={() => navigate("/communication-hub/workflows/create")}>
          New Workflow
        </Button>
      </div>

      <Tabs
        defaultValue="active"
        className="space-y-6"
        tabsListClassName="grid w-full grid-cols-4"
        tabComponents={{
          all: {
            label: "All Workflows",
            component: (
              <div className="space-y-4">
                <WorkflowsManager statusFilter="all" />
              </div>
            ),
          },
          active: {
            label: "Active",
            component: (
              <div className="space-y-4">
                <WorkflowsManager statusFilter="active" />
              </div>
            ),
          },
          drafts: {
            label: "Drafts",
            component: (
              <div className="space-y-4">
                <WorkflowsManager statusFilter="draft" />
              </div>
            ),
          },

          history: {
            label: "History",
            component: (
              <div className="space-y-4">
                {isLoading ? (
                  <div className="flex items-center justify-center py-8">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
                    <span className="ml-2">Loading workflow history...</span>
                  </div>
                ) : (
                  <>
                    <WorkflowHistory
                      executionHistory={
                        workflowRuns?.results.map((run) => ({
                          id: run?.workflow?.toString() ?? "",
                          workflowId: run?.id?.toString() ?? "",
                          workflowName: `Workflow Run ${run.id}`,
                          startedAt: `${run.startDate}T${run.startedAt}`,
                          completedAt: run.completeDate
                            ? `${run.completeDate}T${run.completedAt}`
                            : undefined,
                          status:
                            run.status === 2
                              ? "completed"
                              : run.status === 1
                              ? "in-progress"
                              : "failed",
                          recipientCount: run.recipientsCount,
                          messages: [],
                        })) || []
                      }
                    />
                    <></>
                  </>
                )}
              </div>
            ),
          },
        }}
      />
    </div>
  );
};
